import { render, staticRenderFns } from "./TaskUsersPanel.vue?vue&type=template&id=508ac3f3"
import script from "./TaskUsersPanel.vue?vue&type=script&lang=js"
export * from "./TaskUsersPanel.vue?vue&type=script&lang=js"
import style0 from "./TaskUsersPanel.vue?vue&type=style&index=0&id=508ac3f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports